module.exports = __webpack_public_path__ + "img/icon_menu_graduation_certification.f4b4a39e.svg";